module.exports = __webpack_public_path__ + "media/images/tour/m/id-5665045fa5b833158c502b2fbe9eb915.png";